/* custom javascript for the theme */

document.addEventListener('DOMContentLoaded', function() {
  console.log('[Custom.js] Script loaded');

  const variantInventoryContainer = document.querySelector('.variant-inventory-details');

  if (!variantInventoryContainer) {
    console.log('[Custom.js] No variant inventory container found');
  }

  const variantInventoryDetails = variantInventoryContainer
    ? Array.from(variantInventoryContainer.querySelectorAll('span'))
    : [];

  if (variantInventoryDetails.length) {
    console.log('[Custom.js] Found', variantInventoryDetails.length, 'variant inventory details');
    variantInventoryDetails.forEach(span => {
      console.log('[Custom.js] Variant:', span.dataset.variantId, 'Inventory:', span.dataset.inventoryQuantity);
    });
  } else {
    console.log('[Custom.js] No variant inventory details to cache');
  }

  const variantDataCache = new Map();
  const parsedVariantResources = new Set();
  const productInformationElement =
    variantInventoryContainer?.closest('product-information') || document.querySelector('product-information');
  const defaultSectionId = productInformationElement?.dataset?.sectionId || null;

  recordAnalyticsVariants();
  warmVariantDataCache();

  variantInventoryDetails.forEach(span => {
    const variantId = span.dataset.variantId;
    const rawText = span.textContent || '';
    const variantTitle = rawText.split(' - ')[0]?.trim();
    if (variantId && variantTitle) {
      recordVariantData({
        id: variantId,
        title: variantTitle,
      });
    }
  });

  function getInventoryForVariant(variantId) {
    const variantElement = variantInventoryDetails.find(span => span.dataset.variantId === variantId?.toString());
    return variantElement ? parseInt(variantElement.dataset.inventoryQuantity, 10) : null;
  }

  function toggleBackorderText(variantId, sectionId) {
    console.log('[Custom.js] toggleBackorderText called for variant:', variantId, 'section:', sectionId);

    const inventoryQuantity = getInventoryForVariant(variantId);
    console.log('[Custom.js] Inventory quantity:', inventoryQuantity);

    const backorderElements = document.querySelectorAll('[data-update-id^="backorder-text-"]');
    console.log('[Custom.js] Found', backorderElements.length, 'backorder text elements');

    backorderElements.forEach(element => {
      console.log('[Custom.js] Processing element with id:', element.dataset.updateId);

      if (inventoryQuantity !== null && inventoryQuantity <= 0) {
        console.log('[Custom.js] Showing backorder text - inventory <= 0');
        element.classList.remove('hidden');
      } else {
        console.log('[Custom.js] Hiding backorder text - inventory > 0');
        element.classList.add('hidden');
      }
    });

    const addToCartButtons = document.querySelectorAll('.product--add-to-cart-button');
    console.log('[Custom.js] Found', addToCartButtons.length, 'add-to-cart buttons');

    addToCartButtons.forEach(button => {
      if (inventoryQuantity !== null && inventoryQuantity <= 0) {
        console.log('[Custom.js] Adding backorder-button class');
        button.classList.add('backorder-button');
      } else {
        console.log('[Custom.js] Removing backorder-button class');
        button.classList.remove('backorder-button');
      }
    });
  }

  function normalizeVariant(variant) {
    if (!variant) {
      return null;
    }

    const normalized = { ...variant };
    if (normalized.id !== undefined) {
      normalized.id = String(normalized.id);
    }

    if (!Array.isArray(normalized.options) || !normalized.options.length) {
      const extractedOptions = [];
      for (let index = 1; index <= 3; index += 1) {
        const optionKey = `option${index}`;
        if (normalized[optionKey]) {
          extractedOptions.push(normalized[optionKey]);
        }
      }
      normalized.options = extractedOptions;
    }

    if (Array.isArray(normalized.selectedOptions)) {
      normalized.selectedOptions = normalized.selectedOptions.map(option =>
        typeof option === 'string' ? option : option?.value ?? option,
      );
    }

    return normalized;
  }

  function recordVariantData(variant) {
    const normalized = normalizeVariant(variant);
    if (!normalized || !normalized.id) {
      return null;
    }

    const cacheKey = normalized.id.toString();
    variantDataCache.set(cacheKey, normalized);
    return normalized;
  }

  function getScopeForSection(sectionId) {
    if (sectionId) {
      const scopedProductInformation = document.querySelector(`product-information[data-section-id="${sectionId}"]`);
      if (scopedProductInformation) {
        return scopedProductInformation;
      }
      const scopedElement = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (scopedElement) {
        return scopedElement;
      }
    }

    return productInformationElement || document;
  }

  function warmVariantDataCache(scope) {
    const searchRoot = scope instanceof Element || scope instanceof Document ? scope : document;
    const scripts = searchRoot.querySelectorAll('script[type="application/json"][data-resource]');

    scripts.forEach(script => {
      const resourceId = script.dataset.resource;
      if (resourceId && parsedVariantResources.has(resourceId)) {
        return;
      }

      try {
        const parsed = JSON.parse(script.textContent);
        if (parsed && parsed.id !== undefined) {
          recordVariantData(parsed);
        }
        if (resourceId) {
          parsedVariantResources.add(resourceId);
        }
      } catch (error) {
        console.warn('[Custom.js] Failed to parse variant JSON data resource', resourceId, error);
      }
    });
  }

  function recordAnalyticsVariants() {
    const analyticsVariants = window.ShopifyAnalytics?.meta?.product?.variants;
    if (Array.isArray(analyticsVariants)) {
      analyticsVariants.forEach(recordVariantData);
    }

    const metaVariants = window.meta?.product?.variants;
    if (Array.isArray(metaVariants)) {
      metaVariants.forEach(recordVariantData);
    }
  }

  function getVariantDataById(variantId) {
    if (!variantId) {
      return null;
    }

    const cacheKey = variantId.toString();
    return variantDataCache.get(cacheKey) || null;
  }

  function getCurrentVariantId(sectionId) {
    const scope = getScopeForSection(sectionId);
    const effectiveScope = scope || document;

    const variantInput = effectiveScope.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    const activeSwatch = effectiveScope.querySelector('[data-product-options] .swatch-element.active');
    if (activeSwatch) {
      return (
        activeSwatch.dataset.swatchVariantId ||
        activeSwatch.dataset.selectedSwatchVariantId ||
        activeSwatch.dataset.variantId ||
        null
      );
    }

    const selectedDropdownItem = effectiveScope.querySelector('[data-product-options] .dropdown-list--item.selected');
    if (selectedDropdownItem && selectedDropdownItem.dataset.dropdownVariantId) {
      return selectedDropdownItem.dataset.dropdownVariantId;
    }

    return null;
  }

  function resolveVariantData(variantOrId, sectionId) {
    if (variantOrId && typeof variantOrId === 'object') {
      return recordVariantData(variantOrId);
    }

    recordAnalyticsVariants();

    const candidateId = variantOrId || getCurrentVariantId(sectionId);
    if (!candidateId) {
      return null;
    }

    const cachedVariant = getVariantDataById(candidateId);
    if (cachedVariant) {
      return cachedVariant;
    }

    warmVariantDataCache(getScopeForSection(sectionId));

    return getVariantDataById(candidateId);
  }

  function refreshWallpaperCalculator(variantOrId, sectionId) {
    if (!window.rsWallpaperCalculator) {
      return;
    }

    setTimeout(() => {
      warmVariantDataCache(getScopeForSection(sectionId));
      const resolvedVariant = resolveVariantData(variantOrId, sectionId);
      window.rsWallpaperCalculator.handleVariantChange?.(resolvedVariant, sectionId);
    }, 0);
  }

  if (typeof eventBus !== 'undefined') {
    eventBus.on('variant:change', function(event) {
      console.log('[Custom.js] variant:change event received', event);

      let variantData = null;

      if (event.variant) {
        variantData = recordVariantData(event.variant);
        toggleBackorderText(event.variant.id, event.sectionId);
      } else if (event.variantId || event.id) {
        const fallbackVariant = getVariantDataById(event.variantId || event.id);
        if (fallbackVariant) {
          toggleBackorderText(fallbackVariant.id, event.sectionId);
          variantData = fallbackVariant;
        } else {
          toggleBackorderText(event.variantId || event.id, event.sectionId);
        }
      }

      refreshWallpaperCalculator(variantData || event.variantId || event.id || null, event.sectionId);
    });
  } else {
    console.error('[Custom.js] eventBus is not defined');
  }

  setTimeout(function() {
    const initialVariantId = getCurrentVariantId(defaultSectionId);
    if (initialVariantId) {
      console.log('[Custom.js] Setting initial state for variant:', initialVariantId);
      toggleBackorderText(initialVariantId, defaultSectionId);
      const initialVariantData = resolveVariantData(initialVariantId, defaultSectionId);
      refreshWallpaperCalculator(initialVariantData || initialVariantId, defaultSectionId);
    } else {
      console.log('[Custom.js] No initial variant found');
      refreshWallpaperCalculator(null, defaultSectionId);
    }
  }, 500);
});
